import { Box, Container, Typography, SxProps, Theme } from "@mui/material";

export const CTASection = () => {
  return (
    <Box id="entry-section" sx={sectionSx}>
      <Container maxWidth="lg">
        <Box sx={contentSx}>
          <Typography variant="h2" sx={headingSx}>
            安心と信頼 × 高度な技術力。
            <br />
            そのスタンダードを、一緒につくろう。
          </Typography>
          <Typography sx={subTextSx}>
            まずはお気軽にご連絡ください。選考は面接1回のみ。
            <br />
            学歴・経歴より「本気でエンジニアを目指す気持ち」を大切にしています。
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const sectionSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #22A1B9, #00BFA5)",
  padding: { md: "100px 0", xs: "60px 16px" },
  width: "100%",
  boxSizing: "border-box",
};

const contentSx: SxProps<Theme> = {
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const headingSx: SxProps<Theme> = {
  color: "#FFFFFF",
  fontSize: { md: "40px", xs: "24px" },
  fontWeight: 700,
  marginBottom: { md: "24px", xs: "16px" },
  wordBreak: { md: "keep-all", xs: "normal" },
  lineHeight: 1.4,
};

const subTextSx: SxProps<Theme> = {
  color: "rgba(255, 255, 255, 0.9)",
  fontSize: { md: "18px", xs: "15px" },
  marginBottom: { md: "40px", xs: "32px" },
  lineHeight: 1.8,
};
